import { getColor, mode, StyleFunctionProps, transparentize } from '@chakra-ui/theme-tools';

const baseStyle = {
  container: {
    alignItems: 'flex-start',
    borderRadius: 'lg',
  },
};

function getBg(props: StyleFunctionProps) {
  const { theme, colorScheme: c } = props;
  const lightBg = getColor(theme, `${c}.200`, c);
  const darkBg = transparentize(`${c}.300`, 0.16)(theme);
  return mode(lightBg, darkBg)(props);
}

function variantSubtle(props: StyleFunctionProps) {
  const { colorScheme: c } = props;
  return {
    container: {
      bg: getBg(props),
      border: '2px solid',
      borderColor: mode(`${c}.500`, `${c}.300`)(props),
    },
    icon: { color: mode(`${c}.700`, `${c}.300`)(props) },
  };
}

function variantSolid(props: StyleFunctionProps) {
  const { colorScheme: c } = props;
  return {
    container: {
      bg: mode(`${c}.600`, `${c}.300`)(props),
      color: mode(`white`, `gray.900`)(props),
    },
  };
}

const variants = {
  subtle: variantSubtle,
  solid: variantSolid,
};

export default {
  baseStyle,
  variants,
};
